
import { UnifiedBallotStatus } from "../enums/unified-ballot-status-enum";
import { IConnectEnumValue } from "../models/connect-enum";



export const unifiedBallotStatusConnectEnum: IConnectEnumValue<UnifiedBallotStatus>[] = [
    {
        id: UnifiedBallotStatus.created,
        name: 'created',
        displayText: 'Created'
    },
    {
        id: UnifiedBallotStatus.scheduled,
        name: 'scheduled',
        displayText: 'Scheduled'
    },
    {
        id: UnifiedBallotStatus.openForVoting,
        name: 'openForVoting',
        displayText: 'Open For Voting'
    },
    {
        id: UnifiedBallotStatus.closedForVoting,
        name: 'closedForVoting',
        displayText: 'Closed For Voting'
    },
    {
        id: UnifiedBallotStatus.finalised,
        name: 'finalised',
        displayText: 'Finalised'
    },
    {
        id: UnifiedBallotStatus.pendingClosure,
        name: 'pendingClosure',
        displayText: 'Pending Closure'
    },
    {
        id: UnifiedBallotStatus.deferred,
        name: 'deferred',
        displayText: 'Deferred'
    },
    {
        id: UnifiedBallotStatus.onHold,
        name: 'onHold',
        displayText: 'On Hold'
    },
    {
        id: UnifiedBallotStatus.pendingFinalisedApproval,
        name: 'pendingFinalisedApproval',
        displayText: 'Pending Approval'
    },
    {
        id: UnifiedBallotStatus.reviewComplete,
        name: 'reviewComplete',
        displayText: 'Review Complete'
    }
];

